<template>
  <div>
    <el-form-item>
      <el-checkbox
        v-model="settings.limitsSlowStop"
        label="Apply slow stop factor"
      />
      <div v-show="settings.limitsSlowStop">
        <el-alert
          title="The higher the number, the later throttling will be applied. Value of 1 will give linear reduction. Default is 25."
          :closable="false"
        />

        <el-input-number
          v-model="settings.slowStopFactor"
          :min="1"
          controls-position="left"
        />
      </div>
    </el-form-item>

    <el-divider />

    <el-form-item>
      <el-checkbox
        v-model="settings.limitsRPS"
        label="Apply RPS throttling on approaching limit"
      />
      <div v-show="settings.limitsRPS">
        <el-alert
          title="Number of seconds to exhaust all remaining limit given 100% fill rate. Lower number with INCREASE allowed RPS, higher number will SLOW DOWN the campaign. Default is 480."
          :closable="false"
        />

        <el-input-number
          v-model="settings.RPSFactor"
          :min="1"
          controls-position="left"
        />
      </div>
    </el-form-item>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export type LimitSettings = {
  limitsSlowStop: boolean
  limitsRPS: boolean
  slowStopFactor: number
  RPSFactor: number
}

export default defineComponent({
  name: 'CampaignLimitsSettings',
  props: {
    modelValue: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const settings = ref<LimitSettings>({
      limitsSlowStop: props.modelValue.limits_slow_stop || false,
      limitsRPS: props.modelValue.limits_rps || false,
      slowStopFactor: props.modelValue.slow_stop_factor || 25,
      RPSFactor: props.modelValue.rps_factor || 25
    })

    watch(settings.value, () => {
      context.emit('update:modelValue', {
        ...props.modelValue,
        limits_slow_stop: settings.value.limitsSlowStop,
        limits_rps: settings.value.limitsRPS,
        slow_stop_factor: settings.value.slowStopFactor,
        rps_factor: settings.value.RPSFactor
      })
    })

    return { settings }
  }
})
</script>

<style lang="scss" scoped>
.el-alert {
  margin-bottom: 1rem;
}
</style>
